import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import MailchimpSubscribe from "react-mailchimp-subscribe";

import './Contact.sass';

library.add(fab);

function Contact() {
  const socials = [
    {name: 'Facebook', url: 'https://www.facebook.com/bealtaineceol/',
      icon: 'fa-brands fa-facebook'},
    {name: 'Instagram', url: 'https://www.instagram.com/bealtaineceol/',
      icon: 'fa-brands fa-instagram'},
    {name: 'YouTube', url: 'https://www.youtube.com/@bealtaineceol',
      icon: 'fa-brands fa-youtube'},
    {name: 'Bandcamp', url: 'https://bealtaineceol.bandcamp.com',
      icon: 'fa-brands fa-bandcamp'}
  ];

  const u = '4039cfa06e8251a4af83a40be';
  const id = '23f20b89b2';
  const url = 'https://band.us5.list-manage.com/subscribe/post?u=' +
    u + '&amp;id=' + id;

  const EmailForm = ({status, message, onValidated}) => {
    let email;
    const submit = () =>
      email &&
      email.value.indexOf("@") > -1 &&
      onValidated({
        EMAIL: email.value,
      });

    return (
      <div className="EmailForm">
        {!status ?
          <>
            <input className="EmailInput"
              placeholder="Email"
              ref={node => (email = node)}
              type="email" />
            <button className="EmailButton" onClick={submit}>
              Subscribe
            </button>
          </> :
          <>
            {status === 'sending' && <h2>Sending...</h2>}
            {status === 'success' && <h2>Go raibh maith agat!</h2>}
            {status === 'error' &&
              <h2>Something went wrong! Please try again later.</h2>}
          </>
        }
      </div>
    );
  };

  return (
    <div className="ContactPane">
      <div className="MailingListBlock">
        <h2>Join our email list!</h2>
        <MailchimpSubscribe url={url} render={({subscribe, status, message}) => (
          <EmailForm status={status}
            message={message}
            onValidated={formData => subscribe(formData)} />
        )}/>
        <div className="SocialsBlock">
          {socials.map(site => (
            <a key={site.name} href={site.url} target="_blank" rel="noreferrer" aria-label={site.name}>
              <FontAwesomeIcon icon={site.icon} />
            </a>
          ))}
        </div>
      </div>
      <div className="OtherLinks">
        <div className="BookingBlock">
          <a href="mailto:bealtainepgh@gmail.com">bealtainepgh@gmail.com</a>
          <div className="PhoneBlock">
            <a href="tel:1-412-301-6011">Call us!</a>
            <a href="sms:1-412-301-6011">Text us!</a>
          </div>
          <div className="EPKDownload">
            <a href="/Bealtaine_EPK.zip" download="Bealtaine_EPK.zip">Download our EPK here!</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact;
